import React from "react";

export default function UniversityCapIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M16 4L2 11.0184L4 12.3354V25L6 26V13.6156L15.9908 20L24.2498 14.6593L30 10.9204L16 4Z"
        fill="#9A9A9A"
      />
      <path
        d="M24.3831 16L16 21.4855L7.53319 16L7 21.0956C8 21.874 14 26 16.0001 28C18 26 24 21.8769 25 21.0976L24.3831 16Z"
        fill="#9A9A9A"
      />
    </svg>
  );
}
